import React from '../../_snowpack/pkg/react.js';
import styled from '../../_snowpack/pkg/styled-components.js';
import { colors } from '../css/index.js';
export const SVG = styled.svg.withConfig({
  displayName: "delete__SVG",
  componentId: "g7dg9j-0"
})([".st5,.st6{fill:none;stroke:", ";stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}.st5{stroke-width:1.2;}.st6{stroke-width:0.4;}"], p => p.color);
export default (({
  color = colors.frostbite
} = {}) => /*#__PURE__*/React.createElement(SVG, {
  viewBox: "0 0 40 40",
  color: color
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M29.1,12.6l-2.4,16.6c-0.1,1-1,1.7-2,1.7h-9.5c-1,0-1.8-0.7-2-1.7l-2.4-16.6"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "st6",
  x1: "24.5",
  y1: "16.6",
  x2: "23",
  y2: "26.8"
}), /*#__PURE__*/React.createElement("line", {
  className: "st6",
  x1: "20",
  y1: "26.8",
  x2: "20",
  y2: "16.6"
}), /*#__PURE__*/React.createElement("line", {
  className: "st6",
  x1: "17",
  y1: "26.8",
  x2: "15.5",
  y2: "16.6"
})), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M22.5,9.2h-5c-0.9,0-1.7,0.8-1.7,1.7v1.7h8.4v-1.7C24.2,9.9,23.4,9.2,22.5,9.2z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: "10.9",
  y1: "12.5",
  x2: "26.5",
  y2: "12.5"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
  className: "st5",
  x1: "31.8",
  y1: "12.5",
  x2: "8.2",
  y2: "12.5"
})))));